var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreActionBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.583,
    cy: 20.417,
    r: 1.25,
    transform: "rotate(90 19.583 20.417)",
    fill: "#262626"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.583,
    cy: 15.417,
    transform: "rotate(90 19.583 15.417)",
    fill: "#262626",
    r: 1.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.583,
    cy: 25.417,
    transform: "rotate(90 19.583 25.417)",
    fill: "#262626",
    r: 1.25
  })));
}
export default SvgMoreActionBtn;